<div id="top-menu">
  @if (currentProp) {
    <img [src]="img" id="img-full" [alt]="currentProp.name" />
  }
  <img [src]="profileImg" id="img" class="user-avatar" alt="Photo de profil" />
  <p class="main-text">{{ currentProp ? currentProp.name : userDisplayName }}</p>
  <p class="text">{{ currentProp ? (subtitle | translate) : user.email }}</p>
</div>
<app-main-menu-list></app-main-menu-list>
